export interface Testimonial {
  id: string;
  name: string;
  text: string;
  stars: number;
  treatment: string;
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'Katharina M.',
    text: '„Ich hab vorher echt gezögert, weil ich sehr empfindliche Zähne habe und schon schlechte Erfahrungen gemacht hatte. Bei Jenny hatte ich null Schmerzen — absolut null. Das Ergebnis war direkt nach der Anwendung sichtbar, in gerade mal 60 Minuten. Ich bin immer noch baff."',
    stars: 5,
    treatment: 'Smile Premium',
    date: 'vor 2 Wochen',
  },
  {
    id: '2',
    name: 'Lena S.',
    text: '„45 Minuten, entspannt auf einer bequemen Liege, nettes Gespräch mit Jenny — und danach Zähne, die ich kaum wiedererkannt hab. Kein Brennen, kein Ziehen, nichts. Mein Freund hat es sofort bemerkt, ohne dass ich was gesagt hab. Bessere Empfehlung kann ich nicht geben."',
    stars: 5,
    treatment: 'Smile Classic',
    date: 'vor 5 Wochen',
  },
  {
    id: '3',
    name: 'Sophie T.',
    text: '„Ich wollte meine Zähne vor der Hochzeit etwas aufhellen — nicht mega-weiß, sondern natürlich strahlend. Jenny hat das genau so umgesetzt. Sie hat sich vorher Zeit genommen, die Ausgangsfarbe analysiert und mir erklärt, was realistisch ist. Das Ergebnis: perfekt. Genau das, was ich wollte."',
    stars: 5,
    treatment: 'Smile Starter',
    date: 'vor 3 Monaten',
  },
];
